
import {
    SET_COMPANIES,
} from './types';

import { apiCallV2 } from "../../utils/api";

export const GetCompanies = (page, count, filter, sort) => async (dispatch) => {
    const res = await apiCallV2(
        "GET",
        "/get-companies",
        "",
        localStorage.getItem("access-token"),
        {
            page: page,
            limit: count,
            filters: filter,
            sort: sort,
        },
    );

    dispatch({
        type: SET_COMPANIES,
        data: {
            list: res.data.company,
            count: res.data.count[0]["count(*)"]
        }
    })

}

export const AddCompanyToList = (company) => async (dispatch, getState) => {
    const { list, count } = getState().Company;
    let temp = [...list];

    temp.pop();

    temp.unshift(company);

    dispatch({
        type: SET_COMPANIES,
        data: {
            list: temp,
            count: count
        }
    })
}


export const UpdateCompanyToList = (company, details) => async (dispatch, getState) => {
    const { list, count } = getState().Company;
    let temp = [...list];

    temp = temp.map((l, i) => {
        return company.id != l.id
            ? l
            : {
                ...l,
                ...details
            }
    })

    dispatch({
        type: SET_COMPANIES,
        data: {
            list: temp,
            count: count
        }
    })
}

export const SendVerificationCode = (name, code) => async (dispatch, getState) => {
    const res = await apiCallV2(
        "POST",
        "send-verification-code-to-admin",
        {
            code: code,
            name: name,
        },
        localStorage.getItem("access-token"),
    );

    if (res.status == 200) {
        return true;
    } else {
        return false;
    }
}

export const UpdateCompanyName = (id, name) => async (dispatch, getState) => {
    const res = await apiCallV2(
        "POST",
        "update-company-name",
        {
            id: id,
            name: name,
        },
        localStorage.getItem("access-token"),
    );

    if (res.status == 200 && res.data.data.update == "success") {
        return true;
    } else {
        return false;
    }
}

export const DeactivateCompanyUsers = (id, name) => async (dispatch, getState) => {
    const res = await apiCallV2(
        "POST",
        "deactivate-company",
        {
            id: id,
        },
        localStorage.getItem("access-token"),
    );

    if (res?.status == 200 && res?.data?.data?.update == "success") {
        return {
            success: true,
        }
    } else if (res?.data?.data?.update == "incomplete") {
        return {
            success: false,
            type: 1
        }
    } else if (res?.data?.data?.update == "failed") {
        return {
            success: false,
            type: 0
        }
    }
}
